import { render, staticRenderFns } from "./PodcastsDraggable.vue?vue&type=template&id=a0de3b7e&scoped=true"
import script from "./PodcastsDraggable.vue?vue&type=script&lang=js"
export * from "./PodcastsDraggable.vue?vue&type=script&lang=js"
import style0 from "./PodcastsDraggable.vue?vue&type=style&index=0&id=a0de3b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0de3b7e",
  null
  
)

export default component.exports